import React, { useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import query from '../../query';
import { useHistory } from 'react-router-dom';
import { API_URL } from '../../config/api';
import './ComplaintReply.scss';

const ComplaintNew = ({ loanId, onSuccess }) => {
  const [subjectId, setSubjectId] = useState('');
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState([]);
  const history = useHistory();

  const { data, loading: loadingSubjects } = useQuery(
    query.getComplaintSubjects
  );

  const [createComplaint, { loading }] = useMutation(
    query.createComplaint
  );

  const handleFiles = event => {
    setFiles(Array.from(event.target.files));
  };

  const uploadAttachments = async (complaintMessageId, files) => {
    const formData = new FormData();

    files.forEach(file => {
      formData.append('files[]', file);
    });

    const token = localStorage.getItem('user_auth_data');

    const response = await fetch(
      `${API_URL}/complaint_messages/${complaintMessageId}/attachments`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        body: formData
      }
    );

    if (!response.ok) {
      throw new Error('Unable to upload attachments.');
    }

    return await response.json();
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const { data } = await createComplaint({
        variables: {
          loanId,
          complaintSubjectId: subjectId,
          description: message
        }
      });

      const result = data.createComplaint;

      if (!result.success) {
        alert('Unable to create complaint.');
        return;
      }

      if (files.length > 0) {
        await uploadAttachments(result.complaintMessageId, files);
      }

      history.push(`/Complaints/${result.complaintId}`);

      if (onSuccess) {
        onSuccess(result.complaintId);
      }

    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  if (loadingSubjects) {
    return <div>Loading...</div>;
  }

  return (
    <div className="complaint-reply">

      <h4 className="text-theme">New Complaint</h4>

      <form onSubmit={handleSubmit}>

        <div className="form-group">

          <label>Subject</label>

          <select
            className="form-control"
            value={subjectId}
            onChange={e => setSubjectId(e.target.value)}
          >
            <option value="">Select a subject</option>

            {data.complaintSubjects.map(subject => (
              <option
                key={subject.id}
                value={subject.id}
              >
                {subject.name}
              </option>
            ))}
          </select>

        </div>

        <div className="form-group">

          <label>Description</label>

          <textarea
            className="form-control"
            rows="6"
            placeholder="Describe your complaint..."
            value={message}
            onChange={e => setMessage(e.target.value)}
          />

        </div>

        <div className="form-group">

          <label>Attachments</label>

          <input
            type="file"
            multiple
            onChange={handleFiles}
          />

          {files.length > 0 && (
            <div className="selected-files">
              {files.map(file => (
                <div key={file.name}>
                  <i className="fa fa-paperclip mr-2" />
                  {file.name}
                </div>
              ))}
            </div>
          )}

        </div>

        <div className="text-right">

          <button
            type="submit"
            className="save-button text-white"
            disabled={
              !subjectId ||
              !message.trim() ||
              loading
            }
          >
            {loading ? 'Submitting...' : 'Submit Complaint'}
          </button>

        </div>

      </form>

    </div>
  );
};

export default ComplaintNew;
